export default __webpack_public_path__ + "static/cover-yangol-ceaaeea64cb1758c0b8e36515e60405c.png";